<template>
	<div class="wrap">
		<div class="container">
			<h3 class="personal_titile">我的收藏</h3>
			<div class="list_goodsbox f-clearfix ">

                <van-list v-model="loading" loading-text="加载中..." :finished="finished" finished-text="" @load="getList">
					<div class="iteam_googds" v-for="(value,index) in data_list" :key="'data_list'+index">
						<div class="gl_iterm">
							<router-link :to="{path:'/details', query:{id: value.goods_id}}" class="shopimg_wrap">
								<van-image class="goods_images" :src="value.images">
									<template v-slot:loading>
										<van-loading type="spinner" size="20" />
									</template>
								</van-image>
							</router-link>
							<div class="outer_con">
								<div class="goods_title">
									<router-link :to="{path:'/details', query:{id: value.goods_id}}" class="shopimg_wrap">
										{{value.title}}
									</router-link>
								</div>
								<div class="goods_price">￥{{value.min_price}}</div>
								<van-row type="flex" align="center" justify="center">
									<van-col class="goods_star">
										<van-rate v-model="value.rate" :size="12" color="#FE7A72" />
									</van-col>
									<van-col>评论({{value.comment_count}})</van-col>
								</van-row>
							</div>
							<van-row class="wishist_cz" type="flex" align="center" justify="center">
								<van-button icon="like" size="small" type="primary" v-on:click="removes(value.goods_id)">取消收藏</van-button>
							</van-row>
						</div>
					</div>
					</van-list>
					<van-empty description="没有更多了..." v-if="data_list.length<1" />
			</div>
		</div>
		<v-foot></v-foot>
	</div>
</template>

<script>
	var _this;
	// @ is an alias to /src
	export default {
		components: {},
		created(){
			_this = this;
			// this.getList();
		},
		data() {
			return {
				page: 1,
				data_list:[],
				finished:false,
				loading:false,
				status_getlist:true,
			}
		},
		methods: {
			getList(){
				if(this.status_getlist){
					this.status_getlist = false;
					this.POST("/api/userfavor/mywishlist",{"page":this.page},function (d) {
						// window.console.log(d);
						if(d.code == 0){
							if(_this.data_list.length == 0){
								_this.data_list 	= d.data.data_list;
							}else{
								_this.data_list = _this.data_list.concat(d.data.data_list)
							}
							window.console.log(_this.page+" --- "+d.data.data_list.length +"<"+ d.data.page_size);
							if(d.data.data_list.length < d.data.page_size){
								_this.finished = true;
							}
							_this.loading = false;
							_this.page = _this.page+1;		
							_this.status_getlist = true;			
						}
					})
				}
			},
			removes(gid){
				this.$dialog.confirm({
					title: '提示',
					message: '您确定要继续吗？',
				})
				.then(() => {
					_this.POST("/api/goods/favor",{"id":gid},function (d) {
						if(d.code == 0){
							for(var index in _this.data_list){
								if(_this.data_list[index].goods_id == gid){
									_this.data_list.splice(index, 1);
								}
							}
						}
					})
				})
				.catch(() => {
					// on cancel
				});
			}
		},
	}
</script>